import React, { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const variants = {
  active: {
    label: "KATLAS node active",
    dot: "bg-[#0066FF]",
    text: "text-[#0066FF]",
    border: "border-[#0066FF]/50",
    pulse: true,
  },
  unreachable: {
    label: "KATLAS node unreachable",
    dot: "bg-rose-500",
    text: "text-rose-300",
    border: "border-rose-500/40",
    pulse: false,
  },
  unconfigured: {
    label: "KATLAS node unconfigured",
    dot: "bg-slate-400",
    text: "text-slate-300",
    border: "border-white/15",
    pulse: false,
  },
  misconfigured: {
    label: "KATLAS bearer token missing (legacy API key ignored)",
    dot: "bg-amber-400",
    text: "text-amber-200",
    border: "border-amber-500/40",
    pulse: false,
  },
};

export const NodeStatus = ({ compact = false }) => {
  const [s, setS] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const fetchStatus = async () => {
      try {
        const r = await axios.get(`${API}/katlas/status`);
        if (!cancelled) setS(r.data);
      } catch {
        if (!cancelled) setErr(true);
      }
    };
    fetchStatus();
    const id = setInterval(fetchStatus, 30000);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, []);

  if (err) {
    return (
      <div
        data-testid="node-status"
        data-status="unreachable"
        className={`inline-flex items-center gap-2 px-3 py-1.5 border ${variants.unreachable.border} ${variants.unreachable.text} mono text-[11px] uppercase tracking-[0.18em]`}
      >
        <span className={`w-1.5 h-1.5 ${variants.unreachable.dot}`} />
        Backend unreachable
      </div>
    );
  }

  if (!s) {
    return (
      <div
        data-testid="node-status"
        data-status="loading"
        className="inline-flex items-center gap-2 px-3 py-1.5 border border-white/10 text-slate-500 mono text-[11px] uppercase tracking-[0.18em]"
      >
        <span className="w-1.5 h-1.5 bg-slate-500 animate-pulse" />
        Checking KATLAS node…
      </div>
    );
  }

  const v = variants[s.status] || variants.unreachable;
  return (
    <div
      data-testid="node-status"
      data-status={s.status}
      data-mode={s.mode}
      className={`inline-flex items-center gap-2 px-3 py-1.5 border ${v.border} ${v.text} mono text-[11px] uppercase tracking-[0.18em]`}
      title={s.label}
    >
      <span className={`w-1.5 h-1.5 ${v.dot} ${v.pulse ? "pulse-dot" : ""}`} />
      {compact ? s.label : `${s.label}  ·  mode: ${s.mode}`}
    </div>
  );
};
